import React, { memo } from 'react';
import { withNodeHandles } from './withNodeHandles';
import { NodeData } from '../../store/store';

// Type definitions
interface DefaultStepContentProps {
  data?: NodeData;
  type: string;
}

// Basic node content component (This is the actual visual representation inside the wrapper)
export const DefaultStepContent: React.FC<DefaultStepContentProps> = ({ data, type }) => (
  <span>{data?.name || type || 'Unnamed Step'}</span>
);

// Set display name
DefaultStepContent.displayName = 'DefaultStepContent';

// Create the generic node using the HOC
const GenericStepNode = withNodeHandles(DefaultStepContent);

export default memo(GenericStepNode);
